import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './DashboardLayout.css';

const DashboardLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logoutUser } = useAuth();
  const [mobileMoreOpen, setMobileMoreOpen] = useState(false);

  const handleLogout = () => {
    logoutUser();
    navigate('/');
  };

  const desktopMenuItems = [
    { title: 'DASHBOARD HOME', icon: 'bi-house-door', to: '/dashboard/dashboard' },
    { title: 'MY PROFILE', icon: 'bi-person-badge', to: '/dashboard/profile' },
    { title: 'MY PROGRESS', icon: 'bi-stopwatch', to: '/dashboard/schedule' },
    { title: 'MOCK TEST', icon: 'bi-pencil-square', to: '/dashboard/progress' },
    { title: 'SHARE YOUR FEEDBACK', icon: 'bi-hand-thumbs-up', to: '/dashboard/feedback' },
    { title: 'NOTIFICATION', icon: 'bi-bell', to: '/dashboard/notification' },
  ];

  const mobileNavItems = [
    { title: 'Home', icon: 'bi-house-door', to: '/dashboard/dashboard' },
    { title: 'Progress', icon: 'bi-activity', to: '/dashboard/schedule' },
    { title: 'Tests', icon: 'bi-file-earmark-text', to: '/dashboard/progress' },
    { title: 'Alerts', icon: 'bi-bell', to: '/dashboard/notification' },
    { title: 'More', icon: 'bi-grid', action: 'more' },
  ];

  const isActivePath = (to) => location.pathname === to;

  return (
    <section className="courses-section dashboard-shell">
      <div className="auto-container">
        <div className="row">
          <div className="col-lg-3 col-md-4 col-sm-12 bg-white shadow-sm d-flex flex-column desktop-sidebar">
            {desktopMenuItems.map((item, index) => {
              const isActive = isActivePath(item.to);
              return (
                <Link to={item.to} key={index} className="text-decoration-none">
                  <div
                    className={`d-flex flex-column align-items-center justify-content-center p-4 border-bottom dashboard-sidebar-item ${
                      isActive ? 'dashboard-sidebar-item-active' : ''
                    } hover-shadow`}
                  >
                    <i
                      className={`${item.icon} ${isActive ? 'text-info' : 'text-secondary'} dashboard-sidebar-icon`}
                    ></i>
                    <span
                      className={`mt-2 fw-semibold text-center dashboard-sidebar-label ${isActive ? 'text-primary' : 'text-dark'}`}
                    >
                      {item.title}
                    </span>
                  </div>
                </Link>
              );
            })}

            {/* <div className="d-flex flex-column align-items-center justify-content-center p-4 border-bottom mt-auto">
              <Button variant="outline-danger" onClick={handleLogout} className="w-100">
                LOGOUT
              </Button>
            </div> */}
          </div>

          <div className="col-lg-9 col-md-8 col-sm-12 bg-white shadow-sm content-col">
            <Outlet />
          </div>
        </div>
      </div>

      <nav className="mobile-dashboard-nav" aria-label="Dashboard Navigation">
        {mobileNavItems.map((item) => (
          item.action === 'more' ? (
            <button
              key={item.action}
              type="button"
              className={`mobile-nav-link btn btn-link p-0 border-0 ${mobileMoreOpen ? 'active' : ''}`}
              onClick={() => setMobileMoreOpen((prev) => !prev)}
              aria-label="Open more dashboard links"
            >
              <i className={`bi ${item.icon}`}></i>
              <span>{item.title}</span>
            </button>
          ) : (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setMobileMoreOpen(false)}
              className={`mobile-nav-link ${isActivePath(item.to) ? 'active' : ''}`}
            >
              <i className={`bi ${item.icon}`}></i>
              <span>{item.title}</span>
            </Link>
          )
        ))}
      </nav>

      {mobileMoreOpen ? <div className="mobile-more-backdrop" onClick={() => setMobileMoreOpen(false)} /> : null}
      {mobileMoreOpen ? (
        <div className="mobile-more-sheet" aria-label="More dashboard links">
          <div className="mobile-more-grid">
            {desktopMenuItems.map((item) => (
              <Link
                key={`more-${item.to}`}
                to={item.to}
                onClick={() => setMobileMoreOpen(false)}
                className={`mobile-more-link ${isActivePath(item.to) ? 'active' : ''}`}
              >
                <i className={`bi ${item.icon}`}></i>
                <span>{item.title}</span>
              </Link>
            ))}
          </div>
          <Button
            type="button"
            variant="outline-light"
            className="w-100 mobile-more-logout"
            onClick={() => {
              setMobileMoreOpen(false);
              handleLogout();
            }}
          >
            LOGOUT
          </Button>
        </div>
      ) : null}
    </section>
  );
};

export default DashboardLayout;
